<div class="settings-sidebar" [class.open]="isOpen()">
  <div class="settings-sidebar-header">
    <h5 class="mb-0">Quick Actions</h5>
    <button class="btn-close" (click)="onCloseSidebar()">
      <i antIcon type="close" theme="outline"></i>
    </button>
  </div>
  
  <div class="settings-sidebar-content">
    <div class="shortcuts-list">
      @for (shortcut of shortcuts; track shortcut.title) {
        <div class="shortcut-group">
          <div class="shortcut-item" [class.expandable]="shortcut.type === 'group'" (click)="onShortcutClick(shortcut)">
            <div class="shortcut-icon">
              <i antIcon [type]="shortcut.icon" theme="outline"></i>
            </div>
            <div class="shortcut-content">
              <h6 class="shortcut-title">{{ shortcut.title }}</h6>
              <p class="shortcut-description">{{ shortcut.description }}</p>
            </div>
            @if (shortcut.type === 'group') {
              <div class="expand-icon">
                <i antIcon [type]="shortcut.expanded ? 'minus' : 'plus'" theme="outline"></i>
              </div>
            }
          </div>
          
          @if (shortcut.type === 'group' && shortcut.expanded && shortcut.children) {
            <div class="shortcut-children">
              @for (child of shortcut.children; track child.title) {
                <div class="shortcut-child-group">
                  <div class="shortcut-item child" [class.expandable]="child.type === 'group'" (click)="onShortcutClick(child)">
                    <div class="shortcut-icon">
                      <i antIcon [type]="child.icon" theme="outline"></i>
                    </div>
                    <div class="shortcut-content">
                      <h6 class="shortcut-title">{{ child.title }}</h6>
                      <p class="shortcut-description">{{ child.description }}</p>
                    </div>
                    @if (child.type === 'group') {
                      <div class="expand-icon">
                        <i antIcon [type]="child.expanded ? 'minus' : 'plus'" theme="outline"></i>
                      </div>
                    }
                  </div>
                  
                  @if (child.type === 'group' && child.expanded && child.children) {
                    <div class="shortcut-nested-children">
                      @for (nestedChild of child.children; track nestedChild.title) {
                        <div class="shortcut-item nested-child" (click)="onShortcutClick(nestedChild)">
                          <div class="shortcut-icon">
                            <i antIcon [type]="nestedChild.icon" theme="outline"></i>
                          </div>
                          <div class="shortcut-content">
                            <h6 class="shortcut-title">{{ nestedChild.title }}</h6>
                            <p class="shortcut-description">{{ nestedChild.description }}</p>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

<div class="settings-sidebar-overlay" [class.show]="isOpen()" (click)="onCloseSidebar()"></div>